export default {
  BASE_URL: '',
  api: [
    {
      name: 'list',
      desc: '未收票列表',
      method: 'GET',
      path: '/fm/invoice/purchase/list'
    },
    {
      name: 'detail',
      desc: '未收票-详情',
      method: 'GET',
      path: '/fm/invoice/purchase/detail'
    },
    {
      name: 'orderInvoiceDetail',
      desc: '收票/批量收票',
      method: 'POST',
      path: '/fm/invoice/purchase/select'
    },
    {
      name: 'submitVerificationForm',
      desc: '提交核销单',
      method: 'POST',
      path: '/fm/invoice/purchase/submit'
    },
    {
      name: 'confirmOrderInvoice',
      desc: '收票完成',
      method: 'POST',
      path: '/fm/invoice/purchase/completed'
    },
    {
      name: 'receivingInvoices',
      desc: '开启收票',
      method: 'POST',
      path: '/fm/invoice/purchase/again'
    },
    {
      name: 'invoiceList',
      desc: '发票列表',
      method: 'GET',
      path: '/fm/invoice/list'
    },
    {
      name: 'getInvoiceStatus',
      desc: '收票状态枚举',
      method: 'GET',
      path: '/fm/invoice/purchase/getInvoiceStatus'
    },
    {
      name: 'getInvoiceEnum',
      desc: '发票类型枚举',
      method: 'GET',
      path: '/fm/invoice/getInvoiceEnum'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/inputInvoice/purchase.js